import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';
import { COUNTRY_CODE } from 'src/app/shared/constants/country-code';
import { TermsAndConditionComponent } from '../terms-and-condition/terms-and-condition.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  userForm: FormGroup;
  viewConfirm = false;
  showErrorMessage = true;
  message = '';
  apiCall = false;
  countries = COUNTRY_CODE;
  constructor(private request: DoHttpService,
    public dialog: MatDialog,) { }

  ngOnInit(): void {
    this.userForm = new FormGroup({
      'firstname': new FormControl(null, Validators.required),
      'lastname': new FormControl(null),
      'userName': new FormControl(null, [Validators.required, Validators.email]),
      'countryCode': new FormControl('+45', Validators.required),
      'company': new FormControl(null, Validators.required),
      'phone': new FormControl(null, [Validators.required, numberOnlyValidator]),
      'password': new FormControl('welcometodrawoutapp'),
      'companyRegistrationNumber': new FormControl(null),
    });
  }

  onSubmit() {
    if (this.userForm.valid) {
      console.log(this.userForm.value);
      this.apiCall = true;
      this.request.post(ApiUrls.register, this.userForm.value).subscribe(data => {
        if (data.success) {
          this.viewConfirm = true;
        }
        else {
          this.showErrorMessage = true;
          this.message = data.message;
        }
        this.apiCall = false;
      });
    }
  }

  openTermsAndCondition() {
    const dialogRef = this.dialog.open(TermsAndConditionComponent, {
      width: '80%',
      height: '90%',
      panelClass: ['animate__animated', 'animate__faster', 'animate__fadeInUp', 'rounded-0'],
      autoFocus: false
    });
  }
}

function numberOnlyValidator(control: FormControl): { [key: string]: boolean } | null {
  const value = control.value;
  if (value && isNaN(value)) {
    return { 'notNumber': true };
  }
  return null;
}

